import { useTranslation } from "#hooks";
import { Translations } from "#interfaces";
import { bp } from "#shared/theme";
import React from "react";
import { useMediaQuery } from "react-responsive";
import { ChartContainer } from "../ChartContainer/ChartContainer";
import { GlobalMarketsChartDesktop } from "../GlobalMarketsChartDesktop/GlobalMarketsChartDesktop";
import { GlobalMarketsChartMobile } from "../GlobalMarketsChartMobile/GlobalMarketsChartMobile";
import { InfoItemProps } from "../Info/Info";

export const GlobalMarketsChart: React.FC = () => {
  const { t } = useTranslation("tour");
  const labels = t("GlobalMarketsChart") as Translations;
  const isDesktop = useMediaQuery({ query: bp.m });
  return (
    <ChartContainer
      title={labels.title}
      tooltipContent={labels.tooltip}
      list={(labels.info as unknown) as InfoItemProps[]}
    >
      {isDesktop ? <GlobalMarketsChartDesktop labels={labels} /> : <GlobalMarketsChartMobile labels={labels} />}
    </ChartContainer>
  );
};
